export default {
  // Loading Page
  loading: {
    title: "Preparando tu espacio de trabajo",
    message: "Por favor espera mientras preparamos tu panel de control..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Panel de control",
    recommendations: "Recomendaciones",
    organizationDesign: "Diseño de organización",
    talentPool: "Pool de talentos",
    reports: "Informes",
    notifications: "Notificaciones",
    switchOrg: "Cambiar organización"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relación agregada exitosamente",
    relationshipRemovedSuccessfully: "Relación eliminada exitosamente",
    relationshipSavedSuccessfully: "Relación guardada exitosamente",
    profileCard: "Tarjeta de perfil",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Jerarquía",
      network: "Red"
    },
    searchPlaceholder: "Buscar usuarios...",
    networkSearchPlaceholder: "Buscar red...",
    hierarchySearchPlaceholder: "Buscar jerarquía...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Crear",
      roleCreatedSuccessfully: "Rol creado exitosamente",
      delete: "Eliminar",
      roleDeletedSuccessfully: "Rol eliminado exitosamente",
      addProfile: "Agregar perfil",
      profileAddedSuccessfully: "Perfil agregado exitosamente",
      removeProfile: "Eliminar perfil",
      profileRemovedSuccessfully: "Perfil eliminado exitosamente",
      roleUpdate: "Actualización de rol",
      updatedSuccessfully: "Actualizado exitosamente",
      profileUpdate: "Actualización de perfil",
      profileUpdatedSuccessfully: "Perfil actualizado exitosamente"
    },
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Preguntas Frecuentes",
    question1: "¿Cómo gestiono la configuración de mi organización?",
    question2: "¿Cómo puedo invitar nuevos miembros a mi organización?",
    question3: "¿Cuáles son los diferentes roles y permisos de usuario?",
    question4: "¿Cómo personalizo la marca de mi organización?",
    helpText: "Este es un texto de ayuda de ejemplo. Por favor contacte al soporte para asistencia específica con la configuración y configuración de su organización."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nombre de la organización",
    organizationUsername: "Nombre de usuario de la organización",
    website: "Sitio web",
    workEmail: "Email de trabajo",
    location: "Ubicación",
    organizationType: "Tipo de organización",
    primaryThemeColor: "Color de tema principal",
    secondaryThemeColor: "Color de tema secundario",
    about: "Acerca de",
    saveChanges: "Guardar cambios",
    usernameExists: "Este nombre de usuario ya existe",
    usernameAvailable: "Este nombre de usuario está disponible",
    organizationTypeOptions: {
      business: "Negocio",
      academic: "Académico",
      recruiter: "Reclutador"
    },
    logo: {
      adjustTitle: "Ajustar logo de la organización",
      save: "Guardar",
      uploadButton: "Subir logo",
      incorrectFileType: "Tipo de archivo incorrecto",
      incorrectFileTypeText: "Por favor suba un tipo de archivo de imagen soportado, ej. jpg, png, etc.",
      fileSizeExceeded: "Tamaño de archivo de imagen excedido",
      fileSizeExceededText: "El tamaño de la imagen de perfil debe ser menor a 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Seleccionar",
    acceptInvitation: "Aceptar invitación",
    noOrganizationFound: "¡No se encontró organización!",
    noOrganizationSubtext: "Cree su propia organización primero.",
    createOrganization: "Crear organización",
    myOrganizations: "Mis Organizaciones",
    viewAllOrganizations: "Ver todas las organizaciones",
    pendingInvitation: "Pendiente"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "¡Bienvenido de vuelta! 👋",
    setupComplete: "¡Configuración completa!",
    setupProgress: "Configuración: {step} de 4",
    copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado",
    criticalRoles: "Roles críticos",
    talentPool: "Grupo de talentos",
    integrations: "Integraciones",
    onboarding: "Incorporación",
    activeCandidates: "Candidatos activos",
    connectedApps: "Aplicaciones conectadas",
    pendingOnboards: "Incorporaciones pendientes",
    kvdrReportsCenter: "Centro de reportes KVDR",
    kvdrReportsDescription: "Sumérjase en sus reportes de datos visuales clave y obtenga información crítica.",
    exploreReports: "Explorar reportes >",
    talentPoolExplorer: "Explorador de grupo de talentos",
    talentPoolDescription: "Descubra, analice y gestione su mejor talento con información integral.",
    exploreTalentPool: "Explorar grupo de talentos >",
    thisMonth: "este mes",
    goToOnboarding: "Ir a incorporación"
  },

  // Reports
  reports: {
    title: "Reportes",
    nineCellMatrix: "Matriz de nueve celdas",
    xyPlot: "Gráfico XY",
    talentScoreCard: "Tarjeta de puntuación de talentos",
    emptyReports: "Reportes vacíos",
    createKVDRFirst: "Cree primero un KVDR y planifique para ver reportes",
    // XY Plot specific
    xAxis: "Eje X",
    yAxis: "Eje Y",
    bubbleSize: "Tamaño de burbuja",
    loadingChart: "Cargando gráfico...",
    howToReadChart: "Cómo leer este gráfico",
    positioning: "Posicionamiento",
    horizontalPosition: "La posición horizontal muestra",
    verticalPosition: "La posición vertical muestra",
    bubbleRepresentation: "Representación de burbujas",
    eachBubbleRepresents: "Cada burbuja representa un empleado",
    sizeIndicates: "El tamaño indica",
    quadrants: "Cuadrantes",
    topLeft: "Arriba-Izquierda",
    topRight: "Arriba-Derecha",
    bottomLeft: "Abajo-Izquierda",
    bottomRight: "Abajo-Derecha",
    low: "Bajo",
    high: "Alto",
    interaction: "Interacción",
    hoverOverBubble: "Pase el cursor sobre una burbuja",
    revealsDetailedMetrics: "Revela métricas detalladas para ese empleado",
    colorCoding: "Codificación de colores",
    differentColorsHelp: "Diferentes colores ayudan a distinguir empleados",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Categorización de empleados por matriz de nueve celdas",
    methodologyDescription: "Metodología estandarizada basada en puntuación de rendimiento y preparación para sucesión",
    loading: "Cargando...",
    preparingMatrix: "Preparando la matriz de nueve celdas...",
    noDataAvailable: "No hay datos disponibles",
    employeeAssessmentRequired: "Se requieren datos de evaluación de empleados para mostrar la matriz de nueve celdas.",
    successionReadiness: "Preparación para sucesión",
    performanceScore: "Puntuación de rendimiento",
    bargain: "GANGAS",
    bind: "VINCULAR",
    backup: "RESPALDO",
    onTrack: "EN CAMINO",
    boost: "IMPULSAR",
    build: "CONSTRUIR",
    bootBarter: "BOOT/TRUEQUE",
    employees: "Empleados",
    methodologyTitle: "Metodología de matriz de nueve celdas",
    methodologySubtitle: "Categorización estandarizada de empleados basada en cálculos de puntuación de rendimiento y preparación para sucesión.",
    calculationMethod: "Método de cálculo",
    performanceScoreFormula: "Puntuación de rendimiento (P)",
    performanceScoreCalculation: "P = 0,6 × Rendimiento + 0,4 × Evaluación",
    performanceScoreNote: "Las puntuaciones brutas (-1 a 1,5) se normalizan a escala 0-100",
    successionReadinessFormula: "Preparación para sucesión (R)",
    successionReadinessCalculation: "R = 0,5 × Sucesión + 0,3 × Adecuación + 0,2 × Puntuación de años",
    successionReadinessNote: "Las puntuaciones brutas (-1 a 1,5) se normalizan a escala 0-100",
    yearsScore: "Puntuación de años",
    yearsScoreCalculation: "Si Años ≥ 3: 100, sino: (Años / 3) × 100",
    yearsScoreNote: "Actualmente usa 2 años por defecto (configurable)",
    cellCategories: "Categorías de celdas",
    backupDescription: "Alto rendimiento, Alta sucesión",
    boostDescription: "Rendimiento medio, Alta sucesión",
    bindDescription: "Alta/Media sucesión, Rendimiento bajo/medio",
    onTrackDescription: "Rendimiento medio/bajo, Sucesión media/baja",
    buildDescription: "Rendimiento medio, Sucesión baja",
    bargainDescription: "Rendimiento bajo, Alta sucesión",
    bootBarterDescription: "Alto rendimiento, Sucesión baja",
    // Talent Score Card specific
    criteria: "Criterios",
    talent: "TALENTO",
    role: "ROL",
    remarks: "OBSERVACIONES",
    weightage: "Ponderación",
    good: "Bueno (8-10)",
    average: "Promedio (5-7)",
    poor: "Pobre (1-4)",
    notApplicable: "No aplicable"
  },

  // Talent Pool
  talentPool: {
    title: "Grupo de talentos",
    reviewRequest: "Solicitud de revisión",
    // Main talent pool
    noPendingRequest: "No se encontraron solicitudes pendientes",
    importFrom: "Importar desde",
    uploadExcel: "subir excel",
    uploadResumes: "subir currículos",
    uploadResumesTooltip: "Importar desde currículos (PDF)",
    orHRIS: "o HRIS",
    pendingRequest: "Solicitud pendiente",
    allUsers: "Todos los usuarios",
    addNewEmployee: "Agregar nueva tarjeta de empleado",
    // Table headers
    name: "Nombre",
    email: "Correo electrónico",
    maxRole: "Rol máximo",
    relationships: "Relaciones",
    action: "Acción",
    // User search
    searchUser: "Buscar usuario",
    userNotFound: "Usuario no encontrado.",
    // Relationship management
    member: "Miembro",
    relationship: "Relación",
    addRelation: "Agregar relación",
    removeRelationship: "Eliminar relación",
    // Add employee form
    firstName: "Nombre",
    lastName: "Apellido",
    roleTitle: "Título del rol",
    save: "Guardar",
    // Profile card
    profileCard: "Tarjeta de perfil",
    // Import
    importFromExcel: "Importar desde Excel"
  },

  // Users
  users: {
    title: "Usuarios",
    manageUsers: "Gestionar usuarios",
    // User Recommendations
    talentRecommendations: "Recomendaciones de talento",
    recommendationsDescription: "Basado en su evaluación KVDR, aquí hay recomendaciones personalizadas para su organización",
    viewActivePlans: "Ver planes activos",
    // Recommendation Cards
    fitmentPlan: "Plan de ajuste",
    fitmentPlanDescription: "Incorporación de personas a sus roles.",
    fitmentPlanContent: "Incorporación de personas a sus roles. Mapeo del talento correcto a los roles correctos con indicadores de ajuste",
    developmentPlan: "Plan de desarrollo",
    developmentPlanDescription: "Aprendizaje impulsado por IA con ALEX",
    developmentPlanContent: "Creación de planes de aprendizaje con ALEX Caminos de aprendizaje personalizados para aumentar el valor del talento con habilidades.",
    successionPlanning: "Planificación de sucesión",
    successionPlanningDescription: "Promover y apoyar el crecimiento profesional",
    successionPlanningContent: "Promover y apoyar el crecimiento profesional Planes de coaching para la preparación de habilidades y tiempo para el próximo rol.",
    // Benefits Lists
    roadToRole: "Camino a tu rol (Viaje)",
    skillProfiling: "Perfilado de habilidades",
    learningCredits: "Créditos de aprendizaje",
    marketRewards: "Recompensas del mercado",
    customLearningPaths: "Caminos de aprendizaje personalizados",
    aiAssistedValidation: "Validación asistida por IA",
    progressTracking: "Seguimiento del progreso con Puntos de Experiencia (XPs)",
    interactiveExercises: "Ejercicios interactivos",
    appraisalIndicators: "Indicadores de evaluación 360°",
    goalSettingMentorship: "Establecimiento de metas y mentoría",
    behaviouralCoaching: "Coaching conductual y planes",
    managedCareerGuidance: "Orientación profesional gestionada",
    // Action Buttons
    onboard: "Incorporar",
    activate: "Activar",
    promote: "Promover",
    // Progress Section
    talentCapabilitySnapshot: "Instantánea de capacidades de talento",
    lastUpdated: "Última actualización: Hoy",
    refresh: "Actualizar",
    // Score Labels
    industryLeader: "Líder de la industria",
    highPerforming: "Alto rendimiento",
    competitive: "Competitivo",
    developing: "En desarrollo",
    foundationBuilding: "Construcción de fundamentos",
    // Notifications
    alexActivated: "ALEX activado",
    alexActivatedText: "¡Su asistente de aprendizaje de IA está listo para ayudar!",
    coachingRequestSent: "Solicitud de coaching enviada",
    coachingRequestSentText: "¡Un coach lo contactará pronto!",
    rewardsMarketplace: "Marketplace de recompensas",
    rewardsMarketplaceText: "¡Explorando recompensas y beneficios disponibles!"
  },

  // Integrations
  integrations: {
    title: "Integraciones",
    manageIntegrations: "Gestionar integraciones"
  },

  // Admins
  admins: {
    title: "Administradores",
    manageAdmins: "Gestionar administradores"
  }
};
